module.exports = __webpack_public_path__ + "static/media/Steeple-chase-Rules.805ffe09.pdf";